import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { head } from 'request';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PickingAssignmentServiceService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * get Booking By Filter
   * @param params
   */
  getBooking(params: any): Observable<any>{
    const url = `${environment.whOutboundApiUrl}/pickingAssignment`;
    return this.http.post(url, params);
  }

  /**
   * get Booking Detail By Bookin No
   * @param bookingNo
   */
  getCarTripDetail(params: any): Observable<any>{
    const url = `${environment.whOutboundApiUrl}/pickingAssignment/detail`;
    return this.http.post(url, params);
  }

  /**
   * AssignShipping
   */
  AssignShipping(doNos: any[], assignUser: string, createUser: string, facility: string): Observable<any>{
    const url = `${environment.whOutboundApiUrl}/warehouse/user/${createUser}/pickTasks/Bookings/dos?assignUser=${assignUser}&facility=${facility}`;
    return this.http.post(url, {doNos: doNos});
  }

  /**
   * get Pick Count Summary
   * @param createUser who
   */
  getPickCount(createUser: string): Observable<any>{
    const url = `${environment.whOutboundApiUrl}/Warehouse/PickTaskUserCount/${createUser}`;
    return this.http.get(url);
  }
}
